import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { MainComponent } from "./Main/main.component";
import { HomeComponent } from "./Pages/home/home.component";
import { NotFoundComponent } from "./Pages/not-found/not-found.component";

import { AssistanceComponent } from "./Pages/home/assistance/assistance.component";
import { GeneralConditionsComponent } from "./Pages/home/useful-links-page/condition/general-conditions/general-conditions.component";
import { LegalNoticeComponent } from "./Pages/home/useful-links-page/legal-notice/legal-notice/legal-notice.component";
import { PrivacyPageComponent } from "./Pages/home/privacy-page/privacy-page/privacy-page.component";
import { ContactComponent } from "./Pages/home/contact/contact.component";
import { StoresComponent } from "./Pages/home/stores/stores.component";
import { ResetPasswordComponent } from "./Global/reset-password/reset-password.component";
import { AccountConfirmationComponent } from "./Global/registration-dialog/account-confirmation/account-confirmation.component";

const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "account/confirm/:token",
    component: AccountConfirmationComponent,
    data: { seo: { title: "Confirmation du compte", noindex: true } },
  },
  {
    path: "account/password-reset/:token",
    component: ResetPasswordComponent,
    data: { seo: { title: "Réinitialisation du mot de passe", noindex: true } },
  },

  {
    path: "",
    component: MainComponent,
    children: [
      {
        path: "home",
        component: HomeComponent,
        data: {
          seo: {
            title: "Vente cash et par facilités en Algérie",
            description:
              "Informatique, smartphones, électroménager et meubles en cash ou par facilités de paiement. Commandez en ligne ou dans nos 5 showrooms en Algérie.",
          },
        },
      },
      {
        path: "cart",
        data: { seo: { title: "Mon panier", noindex: true } },
        loadChildren: () =>
          import("./Pages/cart/cart.module").then((m) => m.CartModule),
      },
      {
        path: "assistance",
        component: AssistanceComponent,
        data: {
          seo: {
            title: "Assistance",
            description:
              "Besoin d'aide ? Retrouvez les réponses à vos questions sur les commandes, la livraison, le paiement et les retours chez Wissal Univers.",
          },
        },
      },

      {
        path: "products",
        data: {
          seo: {
            title: "Tous nos produits",
            description:
              "Ordinateurs, smartphones, électroménager, meubles, chauffage… Grandes marques en cash ou par facilités de paiement, livrées dans toutes les wilayas.",
          },
        },
        loadChildren: () =>
          import("./Pages/products/products.module").then(
            (m) => m.ProductsModule,
          ),
      },

      {
        // before `account`: the favorites page is open to logged-out visitors
        path: "account/favorites",
        data: { seo: { title: "Mes favoris", noindex: true } },
        loadChildren: () =>
          import("./Pages/user-account/favorites/favorites.module").then(
            (m) => m.FavoritesModule,
          ),
      },
      {
        path: "account",
        data: { seo: { title: "Mon compte", noindex: true } },
        loadChildren: () =>
          import("./Pages/user-account/user-account.module").then(
            (m) => m.UserAccountModule,
          ),
      },
      {
        path: "account/confirm/:token",
        component: AccountConfirmationComponent,
        data: { seo: { title: "Confirmation du compte", noindex: true } },
      },
      {
        path: "generalconditions",
        component: GeneralConditionsComponent,
        data: { seo: { title: "Conditions générales de vente" } },
      },
      {
        path: "mentionsLegales",
        component: LegalNoticeComponent,
        data: { seo: { title: "Mentions légales" } },
      },
      {
        path: "privacy",
        component: PrivacyPageComponent,
        data: { seo: { title: "Politique de confidentialité" } },
      },
      {
        path: "contact",
        component: ContactComponent,
        data: {
          seo: {
            title: "Contactez-nous",
            description:
              "Une question sur un produit ou une commande ? Contactez l'équipe Wissal Univers par téléphone, e-mail ou via notre formulaire.",
          },
        },
      },
      {
        path: "stores",
        component: StoresComponent,
        data: {
          seo: {
            title: "Showrooms à Alger, Oran, Constantine, Sétif et Mostaganem",
            description:
              "Achetez en cash ou par facilités dans nos 5 showrooms : Alger (Beni Messous), Oran, Constantine, Sétif et Mostaganem. Adresses et téléphones.",
          },
        },
      },
    ],
  },

  {
    path: "not-found",
    component: NotFoundComponent,
    data: { seo: { title: "Page introuvable", noindex: true } },
  },
  { path: "**", redirectTo: "not-found" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
      // anchorScrolling: 'enabled',
      // initialNavigation: 'enabled'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
